import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './styles/globals.css'

// After a deploy, a page left open can ask for a code chunk that no longer exists. Reload once to pick up the
// new build instead of showing a blank screen (guarded so a real outage can't loop).
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('bb:chunkReload') || 0)
    if (Date.now() - last < 60000) return
    sessionStorage.setItem('bb:chunkReload', String(Date.now()))
  } catch {
    // Storage unavailable: the once-only guard can't survive a reload, so don't reload (that could loop).
    return
  }
  event.preventDefault()
  window.location.reload()
})

const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
  },
], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)


